import React from "react";
import PageHeader from "@/components/PageHeader";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  return (
    <>
      <PageHeader
        testId="contact-header"
        eyebrow="Contact"
        title="Engage with Evergreen Global Holdings Ltd."
        intro="For investor relations, strategic partnerships, government engagement or media enquiries, a member of our team will respond personally."
      />

      <section data-testid="contact-body" className="evg-section bg-white">
        <div className="evg-container">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-16 gap-y-12">
            <div className="lg:col-span-5" data-reveal>
              <div className="evg-overline mb-8">Office</div>
              <h2 className="evg-display-lg">United Kingdom</h2>
              <p className="mt-8 evg-body">
                Evergreen Global Holdings Ltd is registered in the United Kingdom. We engage with
                investors, partners and stakeholders globally — with a particular focus across the
                Caribbean.
              </p>

              <div className="mt-14">
                <div className="py-8 border-t border-[#0A1F44]/12">
                  <div className="evg-overline">Investor Relations</div>
                  <a
                    href="mailto:investors@evergreenglobalholdings.com"
                    className="mt-4 block font-serif text-2xl text-[#0A1F44] hover:text-[#D4AF37] transition-colors"
                    data-testid="contact-email-investors"
                  >
                    investors@evergreenglobalholdings.com
                  </a>
                </div>
                <div className="py-8 border-t border-[#0A1F44]/12">
                  <div className="evg-overline">General Enquiries</div>
                  <a
                    href="mailto:contact@evergreenglobalholdings.com"
                    className="mt-4 block font-serif text-2xl text-[#0A1F44] hover:text-[#D4AF37] transition-colors"
                    data-testid="contact-email-general"
                  >
                    contact@evergreenglobalholdings.com
                  </a>
                </div>
                <div className="py-8 border-t border-b border-[#0A1F44]/12">
                  <div className="evg-overline">LinkedIn</div>
                  <a
                    href="https://www.linkedin.com"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="mt-4 block font-serif text-2xl text-[#0A1F44] hover:text-[#D4AF37] transition-colors"
                    data-testid="contact-linkedin"
                  >
                    Evergreen Global Holdings Ltd
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7" data-reveal data-reveal-delay="200">
              <ContactForm sourcePage="contact" testIdPrefix="contact" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
